/* eslint-disable no-unused-vars */
export enum StatisticType {
  Avvenimento = 'match.preview',
  Manifestazione = 'tournament.preview',
  AvvenimentoLive = 'match.lmtPlus',
  Player = 'player.info',
  // NOTE: THE VALUE IS THE SAME AS MANIFESTAZIONE, BECAUSE THE TYPE IS USED ONLY FOR FORCE STAGEID AS PARAM
  Cars = 'match.lmtPlus',
}
/* eslint-enable no-unused-vars */
